// src/importmetadata.js

import geo from "./geograph/metadatas/meta_data_20260211_g";
import mieruka from "./mieruka/meta_mieruka_20260121";

/**
 * 1️⃣ ソースを配列化（増やしやすい構造）
 */
const sources = [geo, mieruka];

/**
 * 2️⃣ マージ（明示的に）
 */
const merged = sources.flatMap((s) => s);

/**
 * 3️⃣ 重複検知（開発時）
 */
const dupKeys = [];
const seen = new Set();
for (const item of merged) {
  const k = String(item.no);
  if (seen.has(k)) dupKeys.push(k);
  seen.add(k);
}
if (dupKeys.length && import.meta?.env?.DEV) {
  console.warn("[metadata] duplicate no (last wins):", dupKeys);
}

/**
 * 4️⃣ no を String に統一して重複排除（後勝ち）
 */
const data_meta = Array.from(
  new Map(merged.map((item) => [String(item.no), item])).values(),
);

/**
 * 5️⃣ O(1)検索用 Map
 */
const data_meta_map = new Map(data_meta.map((item) => [String(item.no), item]));

/**
 * 6️⃣ エクスポート
 */
export { data_meta, data_meta_map };
export default data_meta;
